import { Component, input, output, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReportControl } from '@xmedical/core';
import { XmedicalUiModule } from '@xmedical/ui';

@Component({
  selector: 'xmed-comment-field-renderer',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    XmedicalUiModule
  ],
  templateUrl: './comment-field-renderer.component.html',
  styleUrl: './comment-field-renderer.component.scss'
})
export class CommentFieldRendererComponent implements OnInit {
  control = input.required<ReportControl>();
  value = '';

  valueChanged = output<void>();

  ngOnInit(): void {
    this.value = this.control().value;
  }

  onModelChanged(): void {
    this.valueChanged.emit();
  }
}
